// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"50aff7c7","339":"6e297319","402":"cbadb911","426":"dd40d5a4","472":"71e7fac5","584":"7764122c"}[chunkId] + ".chunk.js";
};